module.exports = __webpack_public_path__ + "img/refresh.1886ceb9.svg";